// @module Ames.Searchspring.Searchspring
define('Ames.Searchspring.Searchspring.View'
,	[
	'ames_searchspring_searchspring.tpl'
	
	,	'Ames.Searchspring.Searchspring.SS2Model'
	
	,	'Backbone'
    ]
, function (
	ames_searchspring_searchspring_tpl
	
	,	SearchspringSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Ames.Searchspring.Searchspring.View @extends Backbone.View
	return Backbone.View.extend({

		template: ames_searchspring_searchspring_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new SearchspringModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Ames.Searchspring.Searchspring.View.Context
	,	getContext: function getContext()
		{
			//@class Ames.Searchspring.Searchspring.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
